import styled, { css } from 'styled-components';

/*TODO: REFACTOR AND REMOVE THIS IS DUPLICATED*/
export const Element = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      gap: 1rem;
      height: 100%; // Required to make Spinner centered
    `;
  }};
`;

/*TODO: REFACTOR AND REMOVE THIS IS DUPLICATED*/
export const Form = styled.form`
  ${({ theme }) => {
    return css`
      padding-bottom: 1rem;
    `;
  }};
`;
